// extracted by mini-css-extract-plugin
export default {"container":"TechSupport_container__dQpfW"};